module.exports = {
          srcSet: __webpack_public_path__ + "2f45a44a0dbb49332028af0fe357561d-984.png"+" 984w",
          images:[ {path: __webpack_public_path__ + "2f45a44a0dbb49332028af0fe357561d-984.png",width: 984,height: 600}],
          src: __webpack_public_path__ + "2f45a44a0dbb49332028af0fe357561d-984.png",
          toString:function(){return __webpack_public_path__ + "2f45a44a0dbb49332028af0fe357561d-984.png"},
          
          width: 984,
          height: 600
        }